import React from 'react'
import FormWrapper from '../../../layout/formLayout/FormWrapper'
import Header from '../../../components/form/Header'
import RegistrationForm from '../../../components/student/auth/RegistrationForm'
import Footer from '../../../layout/student/Footer'

export default function Registration() {
    return (
        <>
            <FormWrapper>

                <div className=''>
                    <Header title="Register Here" />
                    <RegistrationForm />
                </div>

                <Footer/>
            </FormWrapper>
            

        </>
    )
}
